import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnChanges,
    OnDestroy,
    OnInit, SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow, MatRowDef, MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {MatOption} from "@angular/material/autocomplete";
import {MatPaginator} from "@angular/material/paginator";
import {MatSelect} from "@angular/material/select";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatTooltip} from "@angular/material/tooltip";
import {CookieService} from "ngx-cookie-service";
import {DialogService} from "../../_modal/dialog.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomizerSettingsService} from "../../../customizer-settings/customizer-settings.service";
import {OverlayContainer} from "@angular/cdk/overlay";
import {HandleErrorsService} from "../../../services/handle-erros/handle.errors.service";
import {environment} from "../../../../environments/environment";
import {OT_DTO} from "../../_models/OT_DTO";
import {RapportDTO, RapportHistory} from "../../_models/rapport-dto";
import {RapportService} from "../../../services/rapport-service/rapport.service";
import {Endpoints} from "../../endpoints";
import { finalize, tap } from 'rxjs';
import { SampleService } from '../../../services/sample-service/sample.service';
import saveAs from 'file-saver';
import { SampleDTO } from '../../_models/sampleDTO';
import { SignatureComponent } from '../../../signature/signature.component';
import { MatDialog } from '@angular/material/dialog';
import { LotService } from '../../../services/lot-service/lot.service';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../services/user-service/AuthService';

@Component({
    selector: 'app-report',
    standalone: true,
    providers: [DialogService, HandleErrorsService, RapportService, Endpoints],
    imports: [
        DatePipe,
        FormsModule,
        MatButton,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatCell,
        MatCellDef,
        MatCheckbox,
        MatColumnDef,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatError,
        RouterModule,
        MatFormField,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatIconModule,
        MatInput,
        MatLabel,
        MatMenu,
        MatOption,
        MatPaginator,
        MatRow,
        MatRowDef,
        MatSelect,
        MatSort,
        MatSortHeader,
        MatSuffix,
        MatTab,
        MatTabGroup,
        MatTable,
        MatTooltip,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        MatHeaderCellDef,
        MatMenuTrigger,
        NgClass,
        MatNoDataRow
    ],
    templateUrl: './report.component.html',
    styleUrl: './report.component.scss'
})
export class ReportComponent implements OnInit, OnChanges, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    form: FormGroup;
    searchValue: string = '';
    rapport?: RapportDTO;
    rapportId?: number; // ou
    loadingRapport: boolean = false;
    dataSource: MatTableDataSource<RapportDTO> = new MatTableDataSource<RapportDTO>();
    selectedRapport: Set<RapportDTO> = new Set<RapportDTO>(); // Correction du nom
    isAllRapportSelected: boolean = false;
    sampleIds: number[] = [];  // Variable pour stocker les sampleIds associés au rapport



    displayedColumns: string[] = [
        'reportNumber',
        'sampleCode',
        'referenceInterne',
        'status',
        'userName',
        'creationDate',
        'updateDate'
    ];
    columnLabels: Record<string, string> = {
        reportNumber: 'N° rapport',
        sampleCode: 'Code échantillon',
        referenceInterne: 'Référence interne',
        status: 'Statut',
        userName: 'Utilisateur',
        creationDate: 'Date de création',
        updateDate: 'Dernière MAJ',
    };
    columns: string[] = [...this.displayedColumns];

    loadingTable: boolean = true;
    loadingOT: boolean = false;
    loadingPdfGen: boolean = false;
    selectedCountryCode: string;

    constructor(
        private cookieService: CookieService,
        private dialogService: DialogService,       
        private dialog: MatDialog,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private rapportService: RapportService,
        private sampleService:SampleService,
        private handleErrors: HandleErrorsService,
        private lotService:LotService,
        private authService:AuthService

    ) {
        this.initializeForm();
    }
    roles: string[] = [];
    isRL: boolean = false;  // Variable pour vérifier si l'utilisateur est admin

    ngOnInit() {
        this.fetchRapportList();
        this.getColsCookie();
        this.authService.user$.subscribe(user => {
            console.log('Utilisateur connecté :', user); 
            console.log('👤 Utilisateur reçu :', user); 
            console.log('📜 Rôles :', user?.role);
            if (user && user.role && (user.role.includes('RESPONSABLE_QUALITE') || user.role.includes('RESPONSABLE_LABORATOIRE'))) {
                this.isRL = true;
                console.log('Rôle détecté : Responsable Qualité ou Responsable Labo');
            } else {
                this.isRL = false;
            }
            
              
          });
    }
    userHasRole(role: string): boolean {
        return this.roles.includes(role);
      }
      
    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchValue;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';
    }
  
    getSampleCodes(sampleAnalyses: any[]): string {
    if (!sampleAnalyses || sampleAnalyses.length === 0) {
        return '-';
    }

    return sampleAnalyses
        .map(sa => sa.sampleCode)
        .filter(code => !!code)
        .join(', ');
    }
  
    getReferenceInterne(sampleAnalyses: any[]): string {
    if (!sampleAnalyses || sampleAnalyses.length === 0) {
        return '-';
    }

    return sampleAnalyses
        .map(sa => sa.refAnalyse)
        .filter(code => !!code)
        .join(', ');
    }
    initializeForm() {
        this.form = this.fb.group({
            id: [null],
            reportNumber: [null, [Validators.required]],
            clientId: [null, [Validators.required]],
            clientName: [null, [Validators.required, Validators.maxLength(100)]],
            userId: [null, [Validators.required]],
            userName: [null, [Validators.required, Validators.maxLength(100)]],
            sampleId: [null, [Validators.required]],
            sampleCode: [null, [Validators.required, Validators.maxLength(50)]],
            interpretations: [null, [Validators.required]],
            updateDate:[null, [Validators.required]],
        });
    }

    openEditModal(element: RapportDTO, editModal: TemplateRef<RapportDTO>) {
        console.log('Edition du rapport:', element);
        this.rapportId = element.id;
        this.form.patchValue(element);
        this.cdr.detectChanges();
        this.modalService.open(editModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    }
    rapportHistoryList: RapportHistory[] = [];

    selectedHistoryList: RapportHistory[] = [];
    selectedRapportId: number | null = null;
    
    onRapportClick(rapportId: number): void {
      this.selectedRapportId = rapportId;
      this.rapportService.getRapportHistory(rapportId).subscribe({
        next: (data) => this.selectedHistoryList = data,
        error: () => this.dialogService.openDangerAlert("Erreur lors du chargement de l'historique")
      });
    }
    
    downloadPdf(history: RapportHistory): void {
        this.rapportService.downloadPdf(history.id).subscribe(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `rapport_history_${history.versionNumber}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
        }, error => {
          console.error('Erreur téléchargement PDF', error);
        });
      }
      
      
    openViewModel(element: RapportDTO, viewModal: TemplateRef<RapportDTO>) {
        console.log('Affichage du rapport:', element);
        this.rapport = element;
        this.cdr.detectChanges();
        this.modalService.open(viewModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open(
            "Êtes-vous sûr de vouloir supprimer ce rapport ?",
            environment.warning_message_type,
            'danger',
            environment.warning_icon,
            true
        ).then((result: any) => {
            if (result) {
                this.deleteRapport(element.id);
            }
        });
    }

    deleteRapport(id: number) {        this.rapportService.delete(id).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert('Rapport supprimé avec succès');
                }
            }),
            finalize(() => {
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(rapport => rapport.id !== id);
        this.dataSource = new MatTableDataSource<RapportDTO>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

    handleSelection(rapport: RapportDTO) {
        if (this.selectedRapport.has(rapport)) {
            this.selectedRapport.delete(rapport);
            console.log(`Rapport avec ID ${rapport.id} a été désélectionné`);
            
            // Si le rapport qu’on vient de désélectionner est celui affecté à rapportId, on le retire
            if (this.rapportId === rapport.id) {
                this.rapportId = undefined;
                console.log("📛 rapportId réinitialisé car rapport désélectionné");
            }
    
        } else {
            this.selectedRapport.add(rapport);
            console.log(`Rapport avec ID ${rapport.id} a été sélectionné`);
            
            // ✅ Assigner rapportId au premier rapport sélectionné (ou remplacer selon ton besoin)
            this.rapportId = rapport.id;
            console.log("🆔 rapportId affecté :", this.rapportId);
        }
    
        console.log('Rapports sélectionnés:', Array.from(this.selectedRapport).map(item => item.id));
    }
    
    
    handleSelectAll() {
        this.isAllRapportSelected = !this.isAllRapportSelected;
        this.selectedRapport = this.isAllRapportSelected
            ? new Set<RapportDTO>(this.dataSource.filteredData)
            : new Set<RapportDTO>();
    }

    handleIsAllColsSelected(event: MatCheckboxChange) {
        this.displayedColumns = event.checked ? [...this.columns] : [];
        this.setColsCookie();
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action'];
    };

    onSelectionChange(column: string): void {
        this.displayedColumns = this.displayedColumns.includes(column)
            ? this.displayedColumns.filter(c => c !== column)
            : [...this.displayedColumns, column];
        this.setColsCookie();
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`rapportCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const reportCols = this.cookieService.get(`rapportCol_${this.user_name}`);
        if (reportCols) {
            this.displayedColumns = JSON.parse(reportCols);
            console.log('Colonnes récupérées:', reportCols);
        }
    }
resizeSignatureBase64(base64Str: string): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const maxWidth = 300;  // largeur cible
      const maxHeight = 100; // hauteur cible
      let width = img.width;
      let height = img.height;

      // Garder les proportions
      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, width, height);

      // Retourne une image PNG redimensionnée
      const resizedBase64 = canvas.toDataURL('image/png');
      resolve(resizedBase64);
    };

    img.onerror = () => resolve(base64Str); // en cas d’erreur, on garde l’original
  });
}

openSignatureDialog(): void {
  console.log('📨 Ouverture de la boîte de dialogue de signature...');

  const dialogRef = this.dialog.open(SignatureComponent, {
    width: '500px'
  });

  dialogRef.afterClosed().subscribe((signatureBase64: string) => {
    if (!signatureBase64) {
      console.warn('🚫 Aucune signature reçue ou utilisateur a annulé.');
      return;
    }

    const rapportsArray = Array.from(this.selectedRapport);
    if (rapportsArray.length === 0) {
      console.warn('⚠️ Aucun rapport sélectionné.');
      this.dialogService.openDangerAlert("Veuillez sélectionner un rapport à signer.");
      return;
    }

    const rapportId = rapportsArray[0].id;

    this.resizeSignatureBase64(signatureBase64).then((resizedData) => {
      const signatureDTO = {
        rapportId: rapportId,
        signatureData: resizedData
      };

      console.log('📦 Objet à envoyer au backend :', signatureDTO);

      this.lotService.saveSignature(signatureDTO).subscribe({
        next: (response) => {
          console.log('✅ Signature envoyée avec succès :', response);
          this.dialogService.openSuccessDialog(response.message || "Signature enregistrée avec succès.");
          this.fetchRapportList();
        },
        error: (error) => {
          console.error('❌ Erreur lors de la signature :', error);
          const message = error?.error?.message || "Une erreur est survenue lors de la signature.";
          this.dialogService.openDangerAlert(message);
        }
      });
    });
  });
}


    signerRapport() {
        console.log("🧪 ID du rapport à signer :", this.rapportId); // 👈 AJOUT ICI
    
        if (!this.rapportId) {
        this.dialogService.openDangerDialog("L'ID du rapport est introuvable.");
        return;
        }
    
        this.rapportService.signRapport(this.rapportId).subscribe({
        next: (res) => {
            this.dialogService.openSuccessDialog("Signature enregistrée avec succès.");
            this.fetchRapportList(); // Recharge la liste après succès
        },
        error: (err) => {
            const msg = err.error.message || "Erreur lors de la signature";
            this.dialogService.openDangerDialog(msg);
        }
        });
    }

    
    reviserRapport() {
        console.log("🧪 ID du rapport à signer :", this.rapportId); // 👈 AJOUT ICI
    
        if (!this.rapportId) {
        this.dialogService.openDangerDialog("L'ID du rapport est introuvable.");
        return;
        }
    
        this.rapportService.reviserRapport(this.rapportId).subscribe({
        next: (res) => {
            this.dialogService.openSuccessDialog("Rapport révisé avec succès");
            this.fetchRapportList(); // Recharge la liste après succès
        },
        error: (err) => {
            const msg = err.error.message || "Erreur lors de la révision du rapport.";
            this.dialogService.openDangerDialog(msg);
        }
        });
    }
    generateRapport() {
        this.loadingRapport = true;

        if (this.selectedRapport.size < 1) {
            this.dialogService.openDangerDialog('Aucun rapport sélectionné');
            this.loadingRapport = false;
            return;
        }

        // Extraire les IDs des rapports sélectionnés
        let ids: number[] = [];
        this.selectedRapport.forEach((rapport) => {
            ids.push(rapport.id);
        });

        // Exemple : récupérer le pays sélectionné (à adapter selon ta variable)
        const country = this.selectedCountryCode || 'FR';  // valeur par défaut FR

        const payload = {
            sampleIds: ids,
            country: country
        };

        console.log("📌 Rapports sélectionnés : ", this.selectedRapport);
        console.log("📌 Payload envoyé au backend : ", payload);

        this.sampleService.generateRapport(payload).subscribe({
            next: (response: string[]) => {
                console.log("✅ Rapport PDF reçu avec succès !");
                if (response && response.length > 0) {
                    response.forEach((base64String, i) => {
                        // Convertir base64 en Blob PDF
                        const blob = this.base64ToBlob(base64String, 'application/pdf');
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `rapport_${i + 1}.pdf`;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    });
                } else {
                    console.error("La réponse ne contient pas de rapports PDF.");
                    this.dialogService.openDangerDialog('Aucun rapport PDF reçu.');
                }
                this.loadingRapport = false;
            },
            error: (err) => {
                console.error("❌ Erreur lors de la génération du rapport :", err);
                this.loadingRapport = false;
                this.handleErrors.catchError(err);
            }
        });
    }

    // Fonction utilitaire pour convertir base64 en Blob (à garder dans ton component)
    base64ToBlob(base64: string, contentType: string) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

/*
    generateRapport() {
        this.loadingRapport = true;
        
        if (this.selectedRapport.size < 1) {
            this.dialogService.openDangerDialog('Aucun rapport sélectionné');
            this.loadingRapport = false;
            return;
        }
    
        let ids: number[] = [];
        this.selectedRapport.forEach((rapport) => {
            ids.push(rapport.id);
        });
    
        console.log("📌 Rapports sélectionnés : ", this.selectedRapport);
        console.log("📌 IDs envoyés au backend : ", ids);
    
        // Appel au service pour générer les rapports
        this.sampleService.generateRapport(ids).subscribe({
            next: (response: any) => {
                console.log("✅ Rapport PDF reçu avec succès !");
                console.log("Réponse du backend : ", response);
                
                // Vérifier si la réponse contient des fichiers sous forme de 'multipart/form-data'
                if (response && response.files) {
                    console.log("Nombre de fichiers reçus : ", response.files.length);
    
                    // Télécharger chaque fichier reçu
                    for (let i = 0; i < response.files.length; i++) {
                        const file = response.files[i];
                        const blob = new Blob([file], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `rapport_${i + 1}.pdf`; // Nom du fichier basé sur l'index
                        console.log(`Tentative de téléchargement du fichier: rapport_${i + 1}.pdf`);
                        a.click();
                        window.URL.revokeObjectURL(url); // Libérer l'URL après téléchargement
                    }
                } else {
                    console.error("La réponse ne contient pas de fichiers valides.");
                }
    
                this.loadingRapport = false;
            },
            error: (err) => {
                console.error("❌ Erreur lors de la génération du rapport :", err);
                this.loadingRapport = false;
                this.handleErrors.catchError(err);
            }
        });
    }
    

   updateRapport() {
        const rapportData = {
          reportNumber: this.form.value.reportNumber,
          interpretations: this.form.value.interpretations,
          userId: this.form.value.userId,
          sampleId: this.form.value.sampleId,
          clientId: this.form.value.clientId,
          sampleCode: this.form.value.sampleCode,
          updateDate: this.form.value.updateDate ? new Date(this.form.value.updateDate).toISOString() : null
        };
      
        // Appeler le service pour mettre à jour le rapport et récupérer le PDF
        this.rapportService.updateRapportAndGeneratePDF(this.rapportId, rapportData).subscribe({
          next: (response: Blob) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'rapport-' + this.rapportId + '.pdf'; // Nom du fichier PDF
            a.click();
            window.URL.revokeObjectURL(url);
            this.loadingRapport = false;
          },
          error: (err) => {
            console.error('Erreur serveur', err);
            this.loadingRapport = false;
          }
        });
      }
     */ 

      

      updateRapport() {
        const rapportData = {
            reportNumber: this.form.value.reportNumber,
            interpretations: this.form.value.interpretations,
            updateDate: new Date().toISOString().split('T')[0] // Ajouter la date actuelle (format ISO)

             // Assurez-vous d'ajouter les samples si besoin
        };
        if (!rapportData.updateDate) {
            rapportData.updateDate = new Date().toISOString().split('T')[0]; // Current date in ISO format (yyyy-MM-dd)
        }
        console.log('Objet envoyé au backend :', rapportData);
        if (this.rapportId !== undefined) {
         this.rapportService.updateRapport(this.rapportId, rapportData).subscribe({
            next: (response) => {
                if (response.message === 'Report updated successfully') {
                    this.modalService.dismissAll();
                    this.cdr.detectChanges();
                    this.fetchRapportList();      
                    console.log('Rapport mis à jour avec succès');
                } else {
                    console.error('Erreur lors de la mise à jour du rapport', response.message);
                }
            },
            
        });}
    }
    downloadRapport() {
        this.loadingRapport = true;
        if (this.selectedRapport.size < 1) {
            this.dialogService.openDangerDialog('Aucun échantillon sélectionné');
            this.loadingRapport = false;
            return;
        }

        // Récupérer l'ID du rapport sélectionné (vous pouvez adapter cette partie selon la structure de votre modèle)
        const rapportId = Array.from(this.selectedRapport)[0].id;  // Prendre le premier élément sélectionné

        // Appel du service pour télécharger le rapport
        this.rapportService.downloadRapports(rapportId).subscribe(
            (response: Blob) => {
                // Créer un objet URL pour le fichier PDF
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `rapport_${rapportId}.pdf`;  // Nom du fichier à télécharger (avec l'ID du rapport)
                a.click();  // Lancer le téléchargement
                window.URL.revokeObjectURL(url); // Révoquer l'URL une fois l'opération terminée
                this.loadingRapport = false;
            },
            (error) => {
                // Gérer les erreurs
                this.loadingRapport = false;
                this.dialogService.openDangerDialog('Erreur lors du téléchargement du rapport');
                console.error('Erreur lors du téléchargement:', error);
            }
        );
    }
fetchRapportList() {
    console.log("📡 Début fetchRapportList");
    
    this.rapportService.fetchAllRapport().subscribe({
        next: response => {
            console.log('📥 Réponse reçue du backend:', response);
            
            if (response.status) {
                // 1️⃣ Mettre à jour la dataSource
                this.dataSource.data = response.data.map((rapport: { samples: any; }) => ({
                    ...rapport,
                    samples: rapport.samples || []  // fallback si samples undefined
                })) as RapportDTO[];

                console.log("📊 dataSource.data mise à jour :", this.dataSource.data.map(r => r.id));

                // 2️⃣ Rebuild selectedRapport en utilisant les IDs conservés
                const previousSelectedIds = Array.from(this.selectedRapport).map(r => r.id);
                console.log("🔹 IDs sélectionnés avant refresh :", previousSelectedIds);

                // Clear current selection
                this.selectedRapport.clear();
                this.cdr.detectChanges();

                console.log("📌 Sélection finale après refresh :", Array.from(this.selectedRapport).map(r => r.id));
            }

            this.loadingTable = false;
        },
        error: err => {
            console.error("❌ Erreur fetchRapportList:", err);
            this.handleErrors.catchError(err);
            this.loadingTable = false;
        }
    });
}

    
}
